// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3IuO42pd8GxfcMf4w6HfjQ {\n  display: block;\n  margin-bottom: calc(var(--space-small) / 2);\n}\n", ""]);
// Exports
exports.locals = {
	"github": "_3IuO42pd8GxfcMf4w6HfjQ"
};
module.exports = exports;
